export const emailMatcher = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
